import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { MatSort, Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { DocumentDataSource } from 'src/app/acl-data/document/document.datasource';
import { Document } from 'src/app/acl-data/document/document.dto';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { Folder } from 'src/app/acl-data/folder/folder.dto';
import { ObjectStoreService } from 'src/app/acl-data/object-store/object-store.service';
import { environment } from 'src/environments/environment';
import { BatchUploadComponent } from '../batch-upload/batch-upload.component';
import { FileUploader, FileItem } from 'ng2-file-upload';

@Component({
    selector: 'app-browse-transactions',
    templateUrl: './browse-transactions.component.html',
    styleUrls: ['./browse-transactions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrowseTransactionsComponent implements OnChanges {
    @Input() folder: Folder;
    @Input() objectStore: string;

    public uploader: FileUploader = new FileUploader({});

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    loading$ = this.documentService.loading$;
    downloading$ = new BehaviorSubject(false);
    downloadTimedOut = false;
    filenetURL = environment.serviceURL_ACL;

    showDeleted = false;

    userRoles$ = this.objectStoreService.entities$.pipe(
        map(v => v.find(row => row.symbolicName === this.objectStore))
    );

    // folder$ = new BehaviorSubject<Folder>(this.folder);
    documents$ = new BehaviorSubject<string[]>([]);

    // folderObs$ = this.folder$.pipe(filter(v => !!v));
    documentObs$ = this.documents$.pipe(filter(v => !!v));

    dataSource;
    snakbarRef: MatSnackBarRef<any>;

    displayedColumns: string[] = ['select', 'Name', 'DateCreated'];

    selection = new SelectionModel<Document>(true, []);

    download = () => {
        this.downloading$.next(true);
        const ids = this.selection.selected.map(v => v.id);
        console.log('Downloading', ids);

        this.httpClient
            .post(
                `${environment.serviceURL_ACL}/getZip/${this.objectStore}`,
                ids,
                {
                    responseType: 'arraybuffer',
                    headers: { Accept: 'application/zip' },
                }
            )
            .subscribe(
                response => {
                    this.downLoadFile(response, 'application/zip');
                    this.downloading$.next(false);
                },
                error => {
                    console.warn('Download Error');
                    this.downloading$.next(false);
                    this.downloadTimedOut = true;
                    this.cbr.detectChanges();
                }
            );
    };

    /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
    downLoadFile(data: any, typeValue: string) {
        console.log('Download Data');
        const blob = new Blob([data], { type: typeValue });
        const url = window.URL.createObjectURL(blob);
        window.location.href = url;
        // const pwa = window.open(url);
        // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
        //     alert('Please disable your Pop-up blocker and try again.');
        // }
    }

    /** Whether the number of selected elements matches the total number of rows. */
    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    getSelected = () => {
        const results = this.selection.selected.map(v => v.id);
        return results;
    };

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach(row => this.selection.select(row));
    }

    /** The label for the checkbox on the passed row */
    checkboxLabel(row?: Document): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
            row.propertiesObj.DocumentTitle
        }`;
    }

    constructor(
        private documentService: DocumentService,
        private objectStoreService: ObjectStoreService,
        private httpClient: HttpClient,
        private cbr: ChangeDetectorRef,
        private dialog: MatDialog
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (!!this.folder) {
            this.documents$.next(this.folder.documents);
        }
        if (!this.dataSource) {
            this.dataSource = new DocumentDataSource(
                this.documentService,
                this.documents$,
                this.objectStore,
                this.paginator
            );
        }

        this.uploader.onAfterAddingFile = (fileItem: FileItem) => {
            console.log('Added', fileItem.file);
            this.upload(fileItem.file.rawFile);
        };
    }

    changeShowDeleted() {
        this.showDeleted = !this.showDeleted;
        this.dataSource.deleteChanged(this.showDeleted);

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }

    paged(input: PageEvent) {
        this.dataSource.pageChange(input);
    }

    applySort(input: Sort) {
        this.dataSource.sortChanged(input);
    }

    applyFilter(filterValue: string) {
        this.dataSource.filterChange(filterValue.trim().toLowerCase());

        if (this.paginator) {
            this.paginator.firstPage();
        }
    }

    upload = (fileValue?: any) => {
        console.log('Uploading');
        const dialogRef = this.dialog.open(BatchUploadComponent, {
            data: {
                folder: this.folder,
                objectStore: this.objectStore,
                file: fileValue,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('The dialog was closed', result);
            }
        });
    };
}
